import { useEffect, useState } from 'react';
import './App.css';

import Hero from './components/Hero';
import Sky from './components/Sky';
import { SkeletonCards, WeatherCards } from './components/Cards';
import { LANG_BG, useLanguage } from './i18n';
import { getScene, THEME_COLORS } from './scene';
import { useWeatherData } from './useWeatherData';
import { fahToCelsius, formatNumber } from './utils';

function App() {
    const { data: weatherData, offline } = useWeatherData();
    const { language, t, toggleLanguage } = useLanguage();
    const [now, setNow] = useState(() => Date.now());

    // Ticks the "updated x min ago" label.
    useEffect(() => {
        const intervalID = setInterval(() => setNow(Date.now()), 30 * 1000);
        return () => clearInterval(intervalID);
    }, []);

    const scene = getScene(weatherData);
    const tempStr = formatNumber(weatherData ? fahToCelsius(weatherData.tempF) : null, 1);

    useEffect(() => {
        document.documentElement.lang = language === LANG_BG ? 'bg' : 'en';
        document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLORS[scene]);
        document.title = weatherData
            ? `${tempStr}° · ${t.location}`
            : t.location;
    }, [language, scene, weatherData, tempStr, t]);

    return (
        <div className="app" data-scene={scene} aria-busy={weatherData ? undefined : true}>
            <Sky scene={scene} />

            <Hero data={weatherData} offline={offline} now={now} scene={scene} t={t}
                language={language} onLanguageChange={toggleLanguage} />

            {weatherData
                ? <WeatherCards data={weatherData} t={t} />
                : <SkeletonCards />}
        </div>
    );
}

export default App;
